import type { Reference } from '@ps/web-martech-cms-types';
import React, { useRef } from 'react';

import { CMSReferences } from '@swf/cms';
import { useRefs } from '@swf/core/providers/RefsProvider';

import useSetHeaderHeight from '../hooks/useSetHeaderHeight';

interface Props {
  references?: Reference[];
}

const Header: React.FC<Props> = ({ references }) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const { refs } = useRefs();
  const layoutRef = refs.get('sportsLayout');

  useSetHeaderHeight('--sportsLayoutHeaderHeight', layoutRef, headerRef);
  useSetHeaderHeight('--sportsLayoutTopHeaderHeight', layoutRef, refs.get('topHeader'));

  if (!references) return null;

  return (
    <div ref={headerRef}>
      <CMSReferences references={references} />
    </div>
  );
};

export default Header;
